import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WorkbenchIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M28.1432 14.6406H22.6814L25.6437 24.3975C25.7521 24.7543 26.0964 25 26.4881 25H30.1214C30.3974 25 30.6574 24.8771 30.8233 24.6681C30.9893 24.4591 31.042 24.1883 30.9657 23.937L28.1432 14.6406Z"
        fill="currentColor"
      />
      <path
        d="M21.5336 16.8827H10.4664L8.95583 21.8578H23.0441L21.5336 16.8827Z"
        fill="currentColor"
      />
      <path
        d="M3.85677 14.6406L1.03425 23.937C0.957961 24.1883 1.0107 24.4591 1.17669 24.6681C1.34263 24.8771 1.60261 25 1.87859 25H5.51193C5.90357 25 6.24792 24.7543 6.35626 24.3975L9.31864 14.6406H3.85677Z"
        fill="currentColor"
      />
      <path
        d="M30.0769 12.9751H1.92306C1.43784 12.9751 1.0445 12.6022 1.0445 12.1423V8.83276C1.0445 8.37285 1.43784 8 1.92306 8H30.0769C30.5621 8 30.9554 8.37285 30.9554 8.83276V12.1423C30.9555 12.6022 30.5621 12.9751 30.0769 12.9751Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
